import { Flex } from "@chakra-ui/layout";
import colors from "resources/theme/colors";
import { TipoContatoEnum } from "core/features/auth/typings/user";
import { formatPhone } from "infra/helpers/number";
import { Tag } from '@chakra-ui/react';

interface TableItemRowProps {
  bg: string;
  id: string;
  contato: string;
  tipo: TipoContatoEnum;
  receberCobranca:boolean
  borderBottomRadius:number
}

export default function TableItemRow({
  bg,
  id,
  contato,
  tipo,
  receberCobranca,
  borderBottomRadius
}: TableItemRowProps) {
  return (
    <Flex
      justifyContent="space-between"
      bg={bg}
      borderBottomRadius={borderBottomRadius}
      py={3}
      px={2}
      pl={8}
      borderBottomColor={colors.black200}
      borderBottomWidth={1}
      key={id}
    >
      <Flex flex={1}>
        {tipo === TipoContatoEnum.Telefone || tipo === TipoContatoEnum.Celular
          ? formatPhone(contato)
          : contato}
      </Flex>

      <Flex flex={1}>{tipoContatoNome(tipo)}</Flex>

      <Flex flex={1}>{receberCobranca ? <Tag colorScheme='blue'>Receber Cobrança</Tag> : null}</Flex>
    </Flex>
  );
}


function tipoContatoNome(tipoContatoId: TipoContatoEnum) {
    switch (tipoContatoId) {
      case TipoContatoEnum.Email:
        return "Email";
  
      case TipoContatoEnum.Telefone:
        return "Telefone";
  
      case TipoContatoEnum.Celular:
        return "Celular";
  
      default:
        return "Outros";
    }
  }